import { Pipe, PipeTransform } from '@angular/core';
import { parseFloatSafe } from '../func';

@Pipe({
  name: 'unitword'
})
export class UnitWordPipe implements PipeTransform {

  transform(units: string | string[], value: number | string): string {
    value = parseFloatSafe(value)
    if (typeof(units) == 'string') {
      units = units.split('|')
    }
    if (units.length != 3) {
      console.error(units)
      throw new Error('Требуется 3 элемента массива.')
    }
    if (value != Math.round(value)) {
      return units[1]
    }
    if (value - Math.floor(value) != 0) {
      return units[1]
    }
    const cases = [2, 0, 1, 1, 1, 2]
    return units[ (value % 100 > 4 && value % 100 < 20) ? 2 : cases[(value % 10 < 5) ? value % 10 : 5]]
  }

}
